import { styled } from 'styled-components';

export default styled.input`
  flex-grow: 1;
  margin: 0.25rem;
  border: none;
  outline: none;
  border-bottom: 1px solid #ccc;
  height: 36pt;
  font-size: 1.5rem;
  font-family: 'Sanko';
`;
